import { HTTP_STATUS_CODE } from '@mais-retorno-front/data-access-test-2/adapters';
import { AxiosInstance } from 'axios';

interface IResponse {
  nicename: string;
  identifier: string;
  slug: string;
  class: {
    name: string;
    slug: string;
  };
  subclass: {
    name: string;
    slug: string;
  };
  first_quote_date: number;
  last_quote_date: number;
  last_update: number;
  has_quotes: boolean;
}

interface IAssetHeader extends Omit<IResponse, 'class'> {
  class: string;
  id: string;
  assetType: string;
}

export class GetGeneralAssetsHeaderUseCase {
  constructor(private readonly http: AxiosInstance) {}

  async execute(identifier: string): Promise<IAssetHeader> {
    const { data, status } = await this.http.get<IResponse>(
      `/general/header/${identifier}`
    );

    if (status === HTTP_STATUS_CODE.ok) {
      const newAsset = {
        ...data,
        class: data?.class?.name,
        id: identifier.split(':')[0],
        assetType: identifier.split(':')[1],
        slug: data.slug ? `/${data.slug}` : null,
      };

      return newAsset;
    } else {
      throw data;
    }
  }
}
